import OpenAI from 'openai'

const client = new OpenAI({
  apiKey: import.meta.env.VITE_DEEPSEEK_API_KEY,
  baseURL: 'https://api.deepseek.com',
  dangerouslyAllowBrowser: true,
})

export interface MnemonicResult {
  jp: string
  cn: string
}

interface MnemonicContext {
  front: string
  reading: string
}

/**
 * 调用 DeepSeek 生成含卡片元素的日语短句及中文翻译
 */
export async function generateMnemonic(ctx: MnemonicContext): Promise<MnemonicResult> {
  const prompt = `你是一个高水平的日语外教。请针对当前的日语卡片（正面：${ctx.front}，读音：${ctx.reading}），创作一个包含该卡片元素的、极其简单的、适合新手的日语短句。请严格以下列 JSON 格式输出，不要带有任何其他多余的解释、前言或 Markdown 标签： { "jp": "纯日语短句（如：先生はやさしいです。）", "cn": "对应的中文翻译（如：老师很温柔。）" }`

  const res = await client.chat.completions.create({
    model: 'deepseek-chat',
    messages: [{ role: 'user', content: prompt }],
    max_tokens: 150,
    temperature: 0.9,
  })

  const raw = res.choices[0]?.message?.content?.trim() ?? ''

  // 清理可能的 markdown 包装
  const jsonStr = raw.replace(/```json\s*/gi, '').replace(/```\s*/g, '').trim()

  try {
    const parsed = JSON.parse(jsonStr)
    return {
      jp: parsed.jp ?? '',
      cn: parsed.cn ?? '',
    }
  } catch {
    return { jp: '', cn: 'AI 响应解析失败，请稍后重试' }
  }
}
